import * as React from 'react'
import cx from 'classnames'
import FormError from './FormError'
import FormLabel from './FormLabel'
import s from './style.module.scss'

interface ICheckboxProps {
  name: string
  id?: string
  className?: string
  classNameInputWrapper?: string
  style?: React.CSSProperties
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
  defaultValue?: string | boolean | Record<string, any>
  value?: any
  label?: string
  disabled?: boolean
  required?: boolean
  register?: any
  rules?: any
  errors?: Record<string, any>
  checked?: boolean
  showLabelRequired?: boolean
  type?: 'checkbox' | 'radio'
  view?: 'quiz'
  readOnly?: boolean
}

function Checkbox({
  name,
  id,
  className,
  classNameInputWrapper,
  style,
  onChange,
  value,
  label,
  disabled,
  required,
  register,
  rules,
  errors,
  checked = false,
  showLabelRequired,
  type = 'checkbox',
  view,
  ...rest
}: ICheckboxProps) {
  const validation = register ? { ...register(name, rules) } : null
  const isRequired = required || rules?.required?.value

  const formInputWrapperClassList = cx(
    s['form-input-wrapper'],
    {
      [s[type]]: type,
      [s[`view-checkbox-${view}`]]: view,
      [s.error]: errors?.[name]
    },
    classNameInputWrapper
  )

  const inputClassList = cx(s.input, className)

  return (
    <label htmlFor={id} className={formInputWrapperClassList}>
      <div className={s['input-container']}>
        <input
          id={id}
          name={name}
          className={inputClassList}
          style={style}
          type={type}
          onChange={onChange}
          defaultChecked={checked}
          value={value}
          disabled={disabled}
          {...validation}
          {...rest}
        />
        <span className={s.checkmark} />
        <FormLabel label={label} required={isRequired && showLabelRequired} />
      </div>
      <FormError message={errors?.[name]?.message} />
    </label>
  )
}

export default Checkbox
